/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import isArchived from 'archive/isArchived';
import * as AuditActions from 'audit/AuditActions';
import {EXPORT_AUDIT_LOG_DISPLAY_STRING} from 'audit/AuditConstants';
import preferences from 'Preferences';
import {ContainerSchema} from 'samples/storables/StorableSchemaConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import copyToClipboard from 'util/clipboard/copyToClipboard';

interface Props {
  containerSchema: ContainerSchema;
  isWritable: boolean;
  onArchiveContainerSchema: (...args: Array<any>) => any;
  onUnarchiveContainerSchema: (...args: Array<any>) => any;
}

class ContainerSchemaSubheader extends React.Component<Props> {
  _handleArchiveContainerSchema = (): void => {
    this.props.onArchiveContainerSchema(this.props.containerSchema.id);
  };

  _handleCopyContainerSchema = (): void => {
    copyToClipboard(this.props.containerSchema.id, {showToastOnSuccess: true});
  };

  _handleUnarchiveContainerSchema = (): void => {
    this.props.onUnarchiveContainerSchema(this.props.containerSchema.id);
  };

  _handleExportAuditLogs = (): void => {
    AuditActions.exportAuditLogs([this.props.containerSchema.id]);
  };

  override render(): JSX.Element {
    return (
      <div {...getTestProps({component: 'ContainerSchemaSubheader', element: 'root'})}>
        {this.props.isWritable && !isArchived(this.props.containerSchema) && (
          <BenchlingIcon
            className="simpleDivTable-subheaderButton pull-right"
            icon="archive"
            onClick={this._handleArchiveContainerSchema}
            dataTestAttrs={{component: 'ContainerSchemaSubheader', element: 'archiveButton'}}
          />
        )}
        {this.props.isWritable && isArchived(this.props.containerSchema) && (
          <BenchlingIcon
            className="simpleDivTable-subheaderButton pull-right"
            icon="unarchive"
            onClick={this._handleUnarchiveContainerSchema}
            dataTestAttrs={{component: 'ContainerSchemaSubheader', element: 'unarchiveButton'}}
          />
        )}
        <Tooltip container="body" placement={TooltipPlacement.TOP} title={EXPORT_AUDIT_LOG_DISPLAY_STRING}>
          <BenchlingIcon
            className="simpleDivTable-subheaderButton pull-right u-small-spacing-right"
            icon="audit-trail"
            onClick={this._handleExportAuditLogs}
            dataTestAttrs={{component: 'ContainerSchemaSubheader', element: 'auditLogButton'}}
          />
        </Tooltip>
        {Boolean(preferences.get('ENABLE_COPY_API_ID')) && (
          <Tooltip container="body" placement={TooltipPlacement.TOP} title="Copy API ID">
            <BenchlingIcon
              className="simpleDivTable-subheaderButton pull-right u-small-spacing-right"
              icon="note-code"
              onClick={this._handleCopyContainerSchema}
              dataTestAttrs={{component: 'ContainerSchemaSubheader', element: 'copyApiIdButton'}}
            />
          </Tooltip>
        )}
      </div>
    );
  }
}

export default ContainerSchemaSubheader;
